// dockSuggestionsViewModel.js — Area B: Suggestion Dock data (pure, node-testable, no JSX/React).
//
// TASK 9: the dock no longer merges two hardcoded frontend constants. It now derives its flat
// item list from the single checked-in agent library registry (agentLibraryRegistry.json) via
// libraryViewModel.buildDockItems — the SAME source the slider and the library page consume. The
// dock renders the `featured_dock` entries (4 quick tasks + 4 agent jobs = 8 items), tab-filtered
// by `kind`, tasks first then jobs. Job items carry the deterministic "Set up an agent job: …"
// chat-creation template PLUS a verbatim trigger_spec JSON line (C1 blind-guess mitigation). The
// import is synchronous (webpack bundles the JSON), so the dock can never blank on a fetch failure.

import { buildDockItems, getRegistry, CHANNELS } from "./libraryViewModel.js"

// Re-exported so existing importers of the dock's channel palette keep resolving; the canonical
// lookup now lives in libraryViewModel (one palette across dock, slider, and library page).
export { CHANNELS }

// Build the combined, tab-filterable suggestion list from the registry's featured_dock entries.
// Pure — no React import — so this module stays directly node-testable.
export function buildDockSuggestions() {
  return buildDockItems(getRegistry())
}
